import React, { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Logo } from '../components/layout/Logo';
import { useDrawers } from '../contexts/DrawerContext';
import { ArrowLeft, FileText } from 'lucide-react';
export function RouteStub() {
  const location = useLocation();
  const {
    openUpload
  } = useDrawers();
  const pathName = location.pathname.replace('/', '').split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  const title = pathName || 'Page';
  useEffect(() => {
    document.title = `${title} | L.A Property Law`;
    window.scrollTo(0, 0);
  }, [title]);
  return <main className="min-h-[62vh] flex items-center justify-center px-5 md:px-6 py-24" data-id="element-689">
      <div className="max-w-xl w-full text-center" data-id="element-690">
        <div className="flex justify-center mb-8" data-id="element-691">
          <Logo size="lg" data-id="element-692" />
        </div>

        <span className="inline-flex items-center gap-2 rounded-full bg-accent-light text-accent-dark px-4 py-1.5 text-xs font-semibold uppercase tracking-wide mb-6" data-id="element-693">
          Page coming soon
        </span>

        <h1 className="font-serif text-4xl md:text-5xl text-ink leading-tight" data-id="element-694">
          {title}
        </h1>
        <p className="mt-5 text-lg text-muted-ink leading-relaxed" data-id="element-695">
          This page is on its way. In the meantime, you can send your contract
          for review or head back to the homepage to find what you need.
        </p>

        <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-3" data-id="element-696">
          <Button onClick={openUpload} variant="accent" size="lg" data-id="element-697">
            <FileText className="w-5 h-5" data-id="element-698" />
            Upload a contract
          </Button>
          <Link to="/" data-id="element-699">
            <Button variant="outline" size="lg" data-id="element-700">
              <ArrowLeft className="w-4 h-4" data-id="element-701" />
              Back to homepage
            </Button>
          </Link>
        </div>
      </div>
    </main>;
}